module.exports = __webpack_public_path__ + "img/12_Drehschieben-Slido Spinfront@2x.37e3f24c.jpg";